import * as React from "react";
import { useCallback, useMemo } from "react";
import * as Immutable from "immutable";
import { KEY_PREFIX, fetchInputs } from "hooks/usePaginatedInputs";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import CreateInputControl from "components/inputs/CreateInputControl";
import customColumnRenderers from "components/inputs/InputsOveriew/ColumnRenderers";
import getInputsTableElements from "components/inputs/InputsOveriew/Constants";
import useInputsStates from "hooks/useInputsStates";
import useTableElements from "components/inputs/InputsOveriew/useTableElements";
import { IfPermitted } from "components/common";
const entityName = "input";
const InputsOverview = ({
  node = void 0,
  global = void 0,
  inputTypeDescriptions,
  inputTypes,
  entityTableId = void 0,
  withoutURLParams = false
}) => {
  const { data: inputStates } = useInputsStates();
  const { tableLayout, additionalAttributes } = getInputsTableElements();
  const resolvedTableLayout = entityTableId ? { ...tableLayout, entityTableId } : tableLayout;
  const resolvedKeyFn = useCallback(
    (searchParams) => [...KEY_PREFIX, entityTableId != null ? entityTableId : tableLayout.entityTableId, searchParams],
    [entityTableId, tableLayout.entityTableId]
  );
  const { entityActions, expandedSections } = useTableElements({
    inputTypes,
    inputTypeDescriptions
  });
  const columnRenderers = useMemo(() => customColumnRenderers({ inputTypes, inputStates }), [inputTypes, inputStates]);
  const fetchEntities = (options) => {
    const optionsCopy = { ...options };
    if (node) {
      optionsCopy.filters = Immutable.OrderedMap(options.filters).set("node_id", [node.node_id]);
    } else if (global) {
      optionsCopy.filters = Immutable.OrderedMap(options.filters).set("global", ["true"]);
    }
    return fetchInputs(optionsCopy);
  };
  return /* @__PURE__ */ React.createElement("div", null, !node && !global && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "inputs:create" }, /* @__PURE__ */ React.createElement(CreateInputControl, null)), /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "inputs",
      additionalAttributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName }),
      entityActions,
      tableLayout: resolvedTableLayout,
      fetchEntities,
      expandedSectionRenderers: expandedSections,
      keyFn: resolvedKeyFn,
      bulkSelection: void 0,
      withoutURLParams,
      entityAttributesAreCamelCase: false,
      filterValueRenderers: {},
      columnRenderers
    }
  ));
};
export default InputsOverview;
